import React from 'react';
import { NoRemainingItemsContainer, StyledCircleCheckIcon, StyledHeadingXSmall, StyledParagraphMedium } from '../styled-components';
const TITLE = 'No remaining items';
const DESCRIPTION = 'You have no remaining items for this task. Please submit the task if complete';
export const EmptyState = () => {
  return <NoRemainingItemsContainer>
      <StyledCircleCheckIcon />
      <StyledHeadingXSmall>{TITLE}</StyledHeadingXSmall>
      <StyledParagraphMedium>{DESCRIPTION}</StyledParagraphMedium>
    </NoRemainingItemsContainer>;
};